'use client'
import React from 'react'
import styles from './styles.module.scss'

export const ErrorText: React.FC<{
  children: React.ReactNode
  style?: Record<string, string>
}> = ({ children, style = {} }) => (
  <div className={styles.error} style={style}>
    {children}
  </div>
)
